<template>
  <div>
    <v-menu open-on-hover bottom offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="mt-0 ml-6" color="green" dark v-bind="attrs" v-on="on" outlined>
          Xuất danh sách học sinh
        </v-btn>
      </template>

      <v-list>
        <v-list-item class="cursor-pointer">
          <v-list-item-title @click="exportListDataToExcel">Tải xuống tệp Excel danh sách học sinh</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import { mapActions, mapGetters } from 'vuex'
import XLSX from 'xlsx-js-style'

import moment from 'moment'
import { StudentExam } from '../../plugins/api'

export default {
  components: {},
  props: {
    exam: String,
    query: Object
  },
  data() {
    return {
      dialog: false,
      students: null,
      json_list_fields: {
        STT: 'index',
        'Mã định danh Bộ GD&ĐT': 'studentCode',
        'Số báo danh': 'examCode',
        'Họ tên': 'name',
        'Ngày sinh': 'dob',
        'Giới tính': 'gender',
        Lớp: 'class',
        'Phòng thi': 'room',
        'Mã đề': '',
        'Số tờ': '',
        'Kí tên': '',
        'Ghi chú': ''
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['user', 'isAuthenticated'])
  },
  methods: {
    ...mapActions('studentExam', ['fetchStudentExams']),
    formatListDataForExport(data) {
      return data.map((item, index) => {
        let formattedItem = {}
        for (let key in this.json_list_fields) {
          const fieldPath = this.json_list_fields[key]
          let value = item

          // Traverse the field path to get the value
          if (typeof fieldPath === 'string') {
            const pathParts = fieldPath.split('.')
            pathParts.forEach(part => {
              value = value ? value[part] : '' // Set value to '' if it's undefined/null
            })
          }

          // Handle date formatting
          if ((key === 'Ngày sinh' || key === 'Ngày tạo') && value) {
            value = moment(value).format('DD/MM/YYYY')
          }

          // Handle gender formatting
          if (key === 'Giới tính' && value) {
            value = value === 'male' ? 'Nam' : 'Nữ'
          }
          // Add the STT value based on the index
          if (key === 'STT') {
            value = index + 1 // STT starts from 1
          }

          formattedItem[key] = value !== undefined && value !== null ? value : ''

          // Handle special case for 'Số báo danh'
          if (key === 'Số báo danh' && value) {
            formattedItem[key] = { v: value, t: 's' }
          }
        }
        return formattedItem
      })
    },
    async exportListDataToExcel() {
      this.$loading.active = true
      const data = await StudentExam.studentExamExcelSubject({ exam: this.exam })
      const workbook = XLSX.utils.book_new() // Create a new workbook

      data.forEach(subjectData => {
        const formattedData = this.formatListDataForExport(subjectData.students)
        const worksheet = XLSX.utils.json_to_sheet([], { skipHeader: true })

        // Add the headers for the sheet
        const headers = [
          ['SỞ GIÁO DỤC VÀ ĐÀO TẠO HÀ NỘI', ''],
          ['TRƯỜNG THPT Lý Thái Tổ', ''],
          ['', ''],
          ['DANH SÁCH HỌC SINH KIỂM TRA', ''],
          ['NĂM HỌC 2024 - 2025', ''],
          ['', ''],
          ['', '']
        ]

        headers.forEach((header, rowIndex) => {
          const cellAddress = `A${rowIndex + 1}`
          worksheet[cellAddress] = { v: header[0], t: 's' }

          if (rowIndex === 0 || rowIndex === 1) {
            worksheet[cellAddress].s = {
              font: { bold: true, sz: 13, name: 'Times New Roman' },
              alignment: { horizontal: 'left', vertical: 'center' }
            }
          }

          if (rowIndex === 3 || rowIndex === 4) {
            worksheet[cellAddress].s = {
              font: { bold: true, sz: 17, name: 'Times New Roman' },
              alignment: { horizontal: 'center', vertical: 'center' }
            }
          }
        })

        // Define merges for the headers
        worksheet['!merges'] = [
          { s: { r: 3, c: 0 }, e: { r: 3, c: 13 } },
          { s: { r: 4, c: 0 }, e: { r: 4, c: 13 } },
          { s: { r: 5, c: 0 }, e: { r: 5, c: 13 } }
        ]

        // Define common styles for headers and data cells
        const headerStyle = {
          font: { bold: true, sz: 12, name: 'Times New Roman' },
          alignment: { horizontal: 'center', vertical: 'center' },
          border: {
            top: { style: 'thin' },
            bottom: { style: 'thin' },
            left: { style: 'thin' },
            right: { style: 'thin' }
          }
        }

        const dataStyle = {
          font: { sz: 12, name: 'Times New Roman' },
          alignment: { horizontal: 'center', vertical: 'center' },
          border: {
            top: { style: 'thin' },
            bottom: { style: 'thin' },
            left: { style: 'thin' },
            right: { style: 'thin' }
          }
        }

        // Add the actual table data starting from A8
        XLSX.utils.sheet_add_json(worksheet, formattedData, {
          origin: 'A8',
          header: this.getHeaders(),
          skipHeader: false
        })

        // Apply styles to the headers (row 8)
        this.getHeaders().forEach((header, colIndex) => {
          const colLetter = String.fromCharCode(65 + colIndex)
          const headerCellAddress = `${colLetter}8`

          if (worksheet[headerCellAddress]) {
            worksheet[headerCellAddress].s = headerStyle
          }

          if (formattedData.length > 0) {
            for (let rowIndex = 9; rowIndex < formattedData.length + 9; rowIndex++) {
              const dataCellAddress = `${colLetter}${rowIndex}`
              if (worksheet[dataCellAddress]) {
                worksheet[dataCellAddress].s = dataStyle
              }
            }
          }
        })

        if (formattedData.length === 0) {
          this.getHeaders().forEach((header, colIndex) => {
            const colLetter = String.fromCharCode(65 + colIndex)
            const dataCellAddress = `${colLetter}9`
            worksheet[dataCellAddress] = { v: '', t: 's' }
            worksheet[dataCellAddress].s = headerStyle
          })
        }

        this.setColumnWidths(worksheet, formattedData)

        // Add the worksheet to the workbook with the subject name
        XLSX.utils.book_append_sheet(workbook, worksheet, subjectData.subject)
      })

      // Save the workbook with multiple sheets
      XLSX.writeFile(workbook, 'danh-sach-hoc-sinh.xlsx')
      this.$loading.active = false
    },
    setColumnWidths(worksheet, data) {
      let maxWidths = []
      const columnNames = data.length > 0 ? Object.keys(data[0]) : []

      columnNames.forEach((name, index) => {
        maxWidths[index] = name.length
      })

      data.forEach(row => {
        columnNames.forEach((name, index) => {
          const value = (row[name] || '').toString().trim()
          maxWidths[index] = Math.max(maxWidths[index], value.length)
        })
      })

      worksheet['!cols'] = maxWidths.map((width, index) => {
        if (columnNames[index] === 'id') {
          return { width, hidden: true }
        }
        return { width }
      })
    },
    getHeaders() {
      const headers = []
      for (let key in this.json_list_fields) {
        headers.push(key)
      }
      return headers
    }
  }
}
</script>
